import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { sessionServices } from '../services/session.services';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

  constructor(public session: sessionServices) {}

  canActivate() {
    return this.session.isLoggedIn();
   //return true;
  }
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/guard/activateGuard.ts